<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Holiday Preview"
      id="admin_delete_holiday_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn @click="$router.go(-1)" small rounded outlined color="default">
        <v-icon left>mdi-trash-can</v-icon> Cancel Delete
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="holliday.name"
        :icon="'mdi-party-popper'"
        :img_src="holliday.thumb_nail"
        :facts="view_header_facts"
        :description="holliday.description"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete Holiday Concent Form "
      id="admin_delete_holiday_form"
    ></CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="holidays_delete_form_ref"
      id="holidays_delete_form"
      message="<b>Delete was succesfull</b> <br/> Holiday has been removed"
      :is_loading="is_loading"
      :seed="{holliday:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedForm from "../../../components/CardedForm";
import ViewHeader from "../../../components/ViewHeader";
import DeleteConcentForm from "../../../components/DeleteConcentForm";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminHollidaysDelete",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedForm,
    DeleteConcentForm,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      holliday: {
        id: 0,
        name: "",
        description: "",
        starts_on: new Date().toISOString().substr(0, 10),
        ends_on: new Date().toISOString().substr(0, 10),
        thumb_nail: Utils.default_holidays_thumbnail,
      },
      errors: [],
      message: "",
      not_found: false,
      records: null,
      total: 0,
      scan_limit: 0,
    };
  },
  methods: {
    on_success() {
      //go back to hollidays list
      this.$router.push("/admin/hollidays/list");
    },
    load_holliday() {
      this.$emit("on-show-loader");
      ServerClient.Holidays.get_holiday(
        {
          id: this.$route.params.id,
          is_edit: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          console.log("holiday to be deleted ", res);
          if (res == null) {
            this.not_found = true;
          } else {
            this.holliday = res;
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading holliday details on admin delete hollidays",
            errors
          );
        }
      );
    },
  },
  computed: {
    view_header_facts() {
      var facts = [
        { text: "Starts On:", val: this.holliday.starts_on },
        { text: "End On:", val: this.holliday.ends_on },
      ];
      return facts;
    },
  },
  mounted() {
    var holliday_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin Delete Holiday",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Holidays",
          disabled: false,
          href: "/admin/hollidays",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/hollidays/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/hollidays/list/view/" + holliday_id,
        },
        {
          text: "Delete",
          disabled: true,
          href:"/admin/hollidays/list/view/"+holliday_id+"/delete" 
        }
      ],
      navbar_cols: 3
    });
    this.load_holliday();
  },
};
</script>